import { Text } from '@cinch-labs/design-system'
import { formatNumber } from '@cinch-labs/shared-util'
import { Wrapper } from '@cinch-nx/shared-ui'

import TrustpilotStars from './stars/stars'
import TrustpilotLogo from './assets/trustpilot-logo.svg'
import styles from './trustpilot-score.module.css'

const TRUSTPILOT_URL = '/customer-reviews'

interface TrustpilotScoreProps {
  className?: string
  numberOfReviews: number
  starRating: number
  starRatingLabel: string
}

function TrustpilotScore({
  numberOfReviews,
  starRating,
  starRatingLabel,
  className,
}: TrustpilotScoreProps) {
  return (
    <Wrapper
      className={{ container: className }}
      data-testid="trust-pilot-score"
    >
      <a href={TRUSTPILOT_URL} target="_blank" rel="noreferrer">
        <div className={styles.container}>
          <Text>
            Check out our <b>{formatNumber(numberOfReviews)}</b> reviews
          </Text>
          <TrustpilotStars
            className={styles.trustpilotStars}
            starRatingLabel={starRatingLabel}
            starRating={starRating}
          />
          <TrustpilotLogo className={styles.trustpilotLogo} />
        </div>
      </a>
    </Wrapper>
  )
}

export default TrustpilotScore
